import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { AdminQuizzesList } from "./AdminQuizzesList";
import { AdminQuizPage } from "./AdminQuizPage";

const useStyles = makeStyles()((_theme) => ({
	adminQuizzesPage: {}
}));

/**
 * Admin Quizzes Page (App2)
 *
 * List and create/edit use improve-api (useListQuizzes, useGetQuiz, useCreateQuiz, useUpdateQuiz, useDeleteQuiz).
 * Question type pages (boolean/single/multiple choice) still use legacy routes until reimplemented.
 */
export const AdminQuizzesPage: FC = () => {
	const { classes } = useStyles();

	return (
		<Box className={classes.adminQuizzesPage}>
			<Routes>
				<Route index element={<AdminQuizzesList />} />
				<Route path="create" element={<AdminQuizPage />} />
				<Route path=":quizId" element={<AdminQuizPage />} />
			</Routes>
		</Box>
	);
};
